import React, { Component } from 'react';
import { Grid, Col, Row } from 'react-bootstrap';
import { inject, observer, PropTypes as MobxPropTypes } from 'mobx-react'
import MediaQuery from 'react-responsive';

import Profile from '../components/internal/Profile';
import { NavSpacer } from '../components/GeneralStyle';
import InternalRoutes from '../InternalRoutes'
import ChooseDateModal from '../components/internal/BookingModal/ChooseDateModal'
import BookingModal from '../components/internal/BookingModal/BookingModal'

import AcceptContractPopup from '../components/internal/Popups/AcceptContractPopup';
import PayInvoicePopup from '../components/internal/Popups/PayInvoicePopup';
import FillPartnerInformationPopup from '../components/internal/Popups/FillPartnerInformationPopup';
import SharePopup from '../components/internal/Popups/SharePopup';
//import SalesPopup from '../components/internal/Popups/SalesPopup';

import ResidenceBookingModal from '../components/internal/Residence/ResidenceBookingModal/ResidenceBookingModal'
import AdminSideMenu from '../components/admin/AdminSideMenu';
import { LightBackground } from '../components/GeneralStyle'
import { withCookies, Cookies } from 'react-cookie';
import { withRouter } from 'react-router';
import Parse from 'parse'
import { instanceOf } from 'prop-types';

@inject('configStore', 'bookingStore', 'residenceBookingStore', 'blogStore', 'userStore', 'partnerInformationStore')

@observer
class Internal extends Component {

  constructor(props) {
    super(props)
    this.state = {
      showPopups: false,
      adminSideBarClosed: false,
      //showSalesPopup: false,
      // fillPartnerInformationPopupHidden: false
    }

    Parse.Config.get().then(config => { /*this.setState({showSalesPopup: config.get("SHOW_SALES_POPUP")});*/ })

    setTimeout(() => {
      this.setState({showPopups: true})
    }, 1.5 * 1000);


  }

  componentWillMount() {
    this.props.configStore.getParseConfig()
    this.props.blogStore.getActiveBlogPosts()
  }

  componentWillUpdate() {
    const { hasProvidedAllRequiredInformation, showFillInformationPopup } = this.props.partnerInformationStore

    if (this.props.bookingStore.isGolfCourse) {
      this.choosedatemodal.openModal()
    }

    if (this.props.bookingStore.isGolfCourseAndDate) {
      this.bookingmodal.openModal()
    }
    if (this.props.residenceBookingStore.isDate) {
      this.residencebookingmodal.openModal()
    }

    if(!this.state.fillPartnerInformationPopupHidden && hasProvidedAllRequiredInformation) {
      this.setState({ fillPartnerInformationPopupHidden: true })
    }
  }

  render() {

    const { isGolfCourse, isGolfCourseAndDate } = this.props.bookingStore
    const { isDate } = this.props.residenceBookingStore
    const { contractForCurrentYearIsAccepted, contractForNextYearIsAccepted, invoiceForCurrentYearIsPaid, lastUnacceptedContract } = this.props.userStore
    const { hasProvidedAllRequiredInformation, hideInformationPopup, showFillInformationPopup } = this.props.partnerInformationStore

    const isAdmin = this.props.location.pathname.includes("admin");
    // const isAdmin = false;

    return (
      <div className="page">
        <Grid fluid>
          <Row>
            <NavSpacer />

            <MediaQuery query="(min-device-width: 1200px)">
              <LightBackground>
                {isAdmin
                  ?
                  <div style={{display: "flex", height: "100%"}} >
                    <Col sm={this.state.adminSideBarClosed ? 0 : 2} style={{padding: 0, flex: 1, transition: "all 200ms ease-in-out", overflow: "hidden"}} >
                      {/* { !this.state.adminSideBarClosed ? */}
                      <AdminSideMenu close={() => this.setState({adminSideBarClosed: true})}/>
                    </Col>
                    {/* {this.state.adminSideBarClosed && */}
                    <div style={{ width: 0, zIndex: 200 }}>
                      <button
                        onClick={() => this.setState({adminSideBarClosed: !this.state.adminSideBarClosed})}
                        className={"adminMenuToggle"}
                        style={{zIndex: 200, transition: "all 200ms ease-in-out", transform: this.state.adminSideBarClosed ? "" : "translateX(-100%)"}}>
                        { this.state.adminSideBarClosed ?
                          <svg width="24" height="24" viewBox="0 0 24 24">
                            <rect width="24" height="4" x="0" y="1" />
                            <rect width="24" height="4" x="0" y="10" />
                            <rect width="24" height="4" x="0" y="19" />
                          </svg>
                          : "◄"
                        }
                      </button>
                    </div>
                    {/* } */}
                    <Col sm={this.state.adminSideBarClosed ? 12 : 10} style={{transition: "all 200ms ease-in-out"}}>
                      <InternalRoutes />
                    </Col>

                  </div>
                  : <div>
                    <Col sm={12} mdHidden lg={2}>
                      <Profile />
                    </Col>
                    <Col sm={12} md={12} lg={10}>
                      <InternalRoutes />
                    </Col>
                  </div>
                }

                <ChooseDateModal
                  onRef={ref => (this.choosedatemodal = ref)} />
                <BookingModal
                  onRef={ref => (this.bookingmodal = ref)} closeDateModal={() => this.choosedatemodal.closeModal()}/>
                <ResidenceBookingModal
                  onRef={ref => (this.residencebookingmodal = ref)} />
              </LightBackground>
            </MediaQuery>


            <MediaQuery query="(max-device-width: 1199px)">
              <LightBackground>
                {isAdmin
                  ?
                  <Col sm={12} md={12} lg={12}>
                    <InternalRoutes />
                  </Col>
                  : <div>
                    <Col sm={12} md={12} lg={10} className={"no-side-padding"}>
                      <InternalRoutes />
                    </Col>
                    <Col sm={12} mdHidden lg={2} className={"no-side-padding"}>
                      <Profile />
                    </Col>
                  </div>
                }
                <ChooseDateModal
                  onRef={ref => (this.choosedatemodal = ref)} />
                <BookingModal
                  onRef={ref => (this.bookingmodal = ref)} />
                <ResidenceBookingModal
                  onRef={ref => (this.residencebookingmodal = ref)} />

              </LightBackground>
            </MediaQuery>
          </Row>
        </Grid>

        {/* <AcceptContractPopup
          open={this.state.showPopups === true && contractForCurrentYearIsAccepted === false ? true : false}
          year="current"
        />
        <SalesPopup open={this.state.showPopups === true && !this.props.cookies.get('hideSalesPopup1') && this.state.showSalesPopup} />
        */}
        <AcceptContractPopup
          open={this.state.showPopups === true && ( !showFillInformationPopup || hasProvidedAllRequiredInformation ) && lastUnacceptedContract && lastUnacceptedContract.id ? true : false}
          contract={lastUnacceptedContract}
        />
        <PayInvoicePopup
          open={this.state.showPopups === true && ( !showFillInformationPopup || hasProvidedAllRequiredInformation ) && ((lastUnacceptedContract && !lastUnacceptedContract.id) || !lastUnacceptedContract) && invoiceForCurrentYearIsPaid === false ? true : false}
        />
        <FillPartnerInformationPopup
          open={this.state.showPopups === true && !hasProvidedAllRequiredInformation && showFillInformationPopup }
          onClose={ hideInformationPopup }
        />
        {/* <AcceptContractPopup
          open={this.state.showPopups === true && contractForCurrentYearIsAccepted === true && invoiceForCurrentYearIsPaid === true && contractForNextYearIsAccepted === false ? true : false}
          year="next"
        /> */}
      </div>
    );
  }
}
//
Internal.propTypes = {
  configStore: MobxPropTypes.observableObject,
  bookingStore: MobxPropTypes.observableObject,
  blogStore: MobxPropTypes.observableObject,
  residenceBookingStore: MobxPropTypes.observableObject,
  cookies: instanceOf(Cookies).isRequired
};

export default withRouter(withCookies(Internal))



// WEBPACK FOOTER //
// /src/pages/Internal.js